<template>
  <div style="width: 100%;">
    <BaseIndex
      ref="baseIndex"
      :modelNameSingular="modelNameSingular"
      :modelNamePlural="modelNamePlural"
      :pageLoading="pageLoading"
      :loading="loading"
      :table-headers="tableHeaders"
      :table-items="items"
      :maskFields="maskFields"
      :indexNested="true"
    >

      <template slot="new" v-if="!readOnly">
        <New
          @entry-created="entryCreated"
          :modelNameSingular="modelNameSingular"
        />
      </template>
      <template slot="delete" slot-scope="{ item }" v-if="!readOnly">
        <v-icon
            class="mx-1"
            @click="onDelete(item)"
            color="error"
          >
            mdi-delete
          </v-icon>
      </template>
    </BaseIndex>

  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";

export default {
  data() {
    return {
      indexItems: [],
      loading: false,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Produto", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'types', mask: 'tag', color: 'success', outlined: true }, 
      ],
      infoHeaders: [],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Embalagem de venda"
    },
    modelNamePlural: {
      type: String,
      default: "Embalagens de venda"
    },
    items: {
      type: Array,
      default: new Array,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {    
    },
    entryUpdated: function(){
      // this.loadServerEntries();
      // this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(entry){
      // console.log("entry", entry);
      this.items.push(entry);
      // this.loadServerEntries();
      // this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    onDelete: function(item){
      // var index = this.items.findIndex(obj=> obj.id == item.id);
      this.$set(item, "_destroy", true);
      // this.items.splice(index, 1);
    },
  }
};

const LOAD_ALL_PEOPLE = gql `
  query($input: IndexInputObject!) {
    accountContext {
      peopleIndex(input: $input){
        count
        typeOperators
        serverFields      
        personViewIndexFilters {
          id
          code
          kind                           
          name
          type        
          email
          phone
          cities
          routeNames     
          canBeDeleted
          undeletabilityReasons
        }
      }
    }
  }
`;

</script>

<style scoped></style>
